import { inIframe } from '../../utils/inIframe';

export const checkHighestVersionStrategy = (): Promise<number | null> => {
  if (!inIframe()) {
    return Promise.resolve(getVersionWithWindowApi());
  }
  if (!window.Wix) {
    return Promise.reject(new Error('window.Wix is not available'));
  }
  return getVersionWithJsSdk();
};

const getVersionWithWindowApi = (): number | null => {
  const MIN_SDK_VERSION = 4;

  try {
    if (!window.ApplePaySession) {
      return null;
    }
  } catch (e) {
    return null;
  }

  try {
    /*
     * In non-Safari browsers, supportsVersion may always return true, even for invalid versions.
     * To verify support, test with a non-existent version and fall back to the minimum required version if it still returns true
     */
    if (window.ApplePaySession.supportsVersion(99999)) {
      return MIN_SDK_VERSION;
    }

    /**
     * !important
     * Throws error when rendered in not same-origin iframe or on insecure (http://) document.
     * "InvalidAccessError: Trying to start an Apple Pay session from a document with an different security origin than its top-level frame."
     */
    let counter = MIN_SDK_VERSION;
    while (window.ApplePaySession.supportsVersion(counter)) {
      counter++;
    }

    return counter - 1;
  } catch (e) {
    // ignore
  }
};

const getVersionWithJsSdk = async (): Promise<number | null> => {
  let counter = 1;

  if (!window.Wix) {
    return null;
  }

  while (await supportsVersion(counter)) {
    counter++;
  }
  return counter - 1;
};

const supportsVersion = async (counter) => {
  return new Promise<any>((res, rej) => {
    window.Wix.Pay.ApplePay.invokeMethod(
      'supportsVersion',
      { version: counter },
      (r) => {
        res(r.result);
      },
      (e) => {
        rej(e);
      },
    );
  });
};
